<template>
  <svg 
    :width="width" 
    :height="height" 
    viewBox="0 0 28 27" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    class="chat-estrela-icon"
  >
    <path 
      d="M17.7894 17.5993C18.2836 17.5993 18.6843 17.1987 18.6843 16.7045C18.6843 16.2102 18.2836 15.8096 17.7894 15.8096C17.2952 15.8096 16.8945 16.2102 16.8945 16.7045C16.8945 17.1987 17.2952 17.5993 17.7894 17.5993Z" 
      :fill="color"
    />
    <path 
      d="M14.5082 17.5993C15.0024 17.5993 15.4031 17.1987 15.4031 16.7045C15.4031 16.2102 15.0024 15.8096 14.5082 15.8096C14.0139 15.8096 13.6133 16.2102 13.6133 16.7045C13.6133 17.1987 14.0139 17.5993 14.5082 17.5993Z" 
      :fill="color"
    />
    <path 
      d="M21.0707 17.5993C21.5649 17.5993 21.9656 17.1987 21.9656 16.7045C21.9656 16.2102 21.5649 15.8096 21.0707 15.8096C20.5764 15.8096 20.1758 16.2102 20.1758 16.7045C20.1758 17.1987 20.5764 17.5993 21.0707 17.5993Z" 
      :fill="color"
    />
    <path 
      d="M14.2045 22.9026C15.7083 23.773 17.4773 24.0667 19.1817 23.7291C20.8861 23.3915 22.4095 22.4455 23.468 21.0676C24.5264 19.6897 25.0477 17.9739 24.9345 16.2401C24.8213 14.5063 24.0814 12.8728 22.8528 11.6442C21.6242 10.4156 19.9908 9.67576 18.2569 9.56258C16.5231 9.4494 14.8073 9.97062 13.4294 11.0291C12.0515 12.0875 11.1056 13.611 10.768 15.3154C10.4303 17.0197 10.7241 18.7887 11.5944 20.2926L10.6615 23.0779C10.6264 23.183 10.6214 23.2958 10.6468 23.4037C10.6723 23.5115 10.7272 23.6101 10.8056 23.6885C10.884 23.7668 10.9826 23.8218 11.0904 23.8473C11.1983 23.8727 11.3111 23.8676 11.4162 23.8326L14.2045 22.9026Z" 
      :stroke="color" 
      stroke-width="1.2" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
    <path 
      d="M2.26934 3.88052C2.38184 3.41654 3.04171 3.41654 3.15422 3.88052L3.46378 5.15716C3.50395 5.32281 3.63329 5.45214 3.79894 5.49231L5.07558 5.80188C5.53955 5.91439 5.53955 6.57425 5.07558 6.68676L3.79894 6.99632C3.77823 7.00135 3.75809 7.00776 3.73862 7.01546C3.60235 7.06939 3.49893 7.18653 3.46378 7.33148L3.15422 8.60812C3.14718 8.63712 3.13802 8.6643 3.12698 8.68967C2.96137 9.07028 2.37481 9.04309 2.26934 8.60812L1.95977 7.33148C1.95726 7.32113 1.9544 7.31091 1.95121 7.30086C1.90329 7.15001 1.77991 7.03398 1.62462 6.99632L0.347976 6.68676C0.318978 6.67973 0.291793 6.67056 0.26642 6.65952C-0.11418 6.4939 -0.0869942 5.90735 0.347976 5.80188L1.62462 5.49231C1.79027 5.45214 1.9196 5.32281 1.95977 5.15716L2.26934 3.88052Z" 
      :fill="color"
    />
    <path 
      d="M8.91585 9.77455C8.91585 10.3736 8.43021 10.8593 7.83114 10.8593C7.23207 10.8593 6.74642 10.3736 6.74642 9.77455C6.74642 9.17547 7.23207 8.68983 7.83114 8.68983C8.43021 8.68983 8.91585 9.17547 8.91585 9.77455Z" 
      :fill="color"
    />
    <path 
      d="M8.14927 0.347981C8.26177 -0.115994 8.92164 -0.115994 9.03415 0.347981L9.34371 1.62462C9.38388 1.79027 9.51322 1.91961 9.67887 1.95978L10.9555 2.26934C11.4195 2.38185 11.4195 3.04171 10.9555 3.15422L9.67887 3.46379C9.65816 3.46881 9.63802 3.47522 9.61856 3.48293C9.48228 3.53686 9.37886 3.654 9.34371 3.79894L9.03415 5.07558C9.02711 5.10458 9.01795 5.13177 9.0069 5.15714C8.8413 5.53774 8.25474 5.51056 8.14927 5.07558L7.8397 3.79894C7.83719 3.78859 7.83433 3.77838 7.83114 3.76832C7.78323 3.61747 7.65984 3.50145 7.50455 3.46379L6.22791 3.15422C6.19891 3.14719 6.17172 3.13802 6.14635 3.12698C5.76575 2.96137 5.79294 2.37482 6.22791 2.26934L7.50455 1.95978C7.6702 1.91961 7.79953 1.79027 7.8397 1.62462L8.14927 0.347981Z" 
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: 'ChatEstrelaIcon',
  props: {
    color: {
      type: String,
      default: '#4B089F'
    },
    width: {
      type: [String, Number],
      default: 24
    },
    height: {
      type: [String, Number],
      default: 24
    }
  }
}
</script>

<style scoped>
.chat-estrela-icon {
  display: inline-block;
  vertical-align: middle;
}
</style>
